export default {
    menu_account_notifications_title: "Notifications",
    menu_account_notifications_export: "Export File",
    menu_account_notifications_export_message: "Click to download the export file",
    menu_account_notifications_mark_as_read: "Mark as read",
    menu_account_notifications_file_generated: "The export file has been generated and is available on the section of notifications",
    menu_account_export_pending_label: "Generating export",
    menu_account_export_complete_label: "Export ready",
    menu_account_export_expired_label: "Export timed out. Please try again.",
    menu_account_export_download: "Download",
    menu_account_export_copy_link: "Copy link",
    menu_account_export_copied: "Copied",
    menu_account_export_dismiss: "Dismiss",
    menu_account_export_elapsed: "Elapsed",
    menu_account_export_expires_in: "Expires in",
};